export const authClasses = {
  container:
    "min-h-screen w-screen bg-[#1c1d21] px-4 py-8 text-sm font-medium text-slate-100 md:px-8",
  authShell:
    "mx-auto grid min-h-[calc(100vh-4rem)] w-full max-w-5xl items-center gap-8 lg:grid-cols-[1.05fr_0.95fr]",
  authIntro:
    "rounded-lg border border-white/10 bg-white/[0.03] p-6 shadow-2xl shadow-black/20 md:p-8",
  authCard:
    "w-full rounded-lg border border-white/10 bg-[#24262c] shadow-2xl shadow-black/30",
  authCardHeader: "grid gap-2 border-b border-white/10 px-5 py-5 md:px-6",
  form: "grid gap-5 p-5 md:p-6",
  button:
    "flex min-h-[46px] items-center justify-center gap-x-2 rounded-md border border-accent-color-1 bg-accent-color-1 px-4 py-3 font-bold text-white transition hover:border-[#c75a48] hover:bg-[#c75a48] disabled:cursor-not-allowed disabled:opacity-60",
  buttonSmall:
    "my-2 flex items-center justify-center gap-x-2 rounded-md border border-accent-color-1 bg-accent-color-1 px-2 py-1 text-white transition hover:border-[#c75a48] hover:bg-[#c75a48]",
  input:
    "min-h-[46px] w-full rounded-md border border-white/15 bg-white/[0.06] px-4 py-3 text-slate-100 outline-none transition placeholder:text-slate-500 focus:border-accent-color-2 focus:ring-2 focus:ring-[rgba(108,207,246,0.2)]",
  text: "text-slate-400",
  textLight: "text-slate-300",
  link:
    "cursor-pointer font-bold text-accent-color-2 underline underline-offset-4 transition hover:text-white",
  hr: "w-full border-white/10",
  forgotPasswordButton:
    "mx-3 w-full text-slate-400 transition hover:text-accent-color-2",
  disabledButton:
    "flex min-h-[46px] items-center justify-center gap-x-2 rounded-md bg-gray-700 px-4 py-3",
};
